import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { AdminOrdersComponent } from './components/admin-orders/admin-orders.component';
import { AdminOverviewComponent } from './components/admin-overview/admin-overview.component';
import { CallbackComponent } from './components/callback/callback.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { FavouritesComponent } from './components/favourites/favourites.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { HomeComponent } from './components/home/home.component';
import { ImageListComponent } from './components/image-list/image-list.component';
import { ManageStockItemComponent } from './components/manage-stock-item/manage-stock-item.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { ProductComponent } from './components/product/product.component';
import { ReturnsPolicyComponent } from './components/returns-policy/returns-policy.component';
import { SearchComponent } from './components/search/search.component';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { StockListComponent } from './components/stock-list/stock-list.component';
import { TermsComponent } from './components/terms/terms.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'collection/:collection/:type', component: GalleryComponent },
  { path: 'item/:code', component: ProductComponent },
  { path: 'product/:slug', component: ProductComponent },
  { path: 'search', component: SearchComponent },
  { path: 'logged-in/callback', component: CallbackComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'cookie-policy', component: CookiePolicyComponent },
  { path: 'disclaimer', component: DisclaimerComponent },
  { path: 'favourites', component: FavouritesComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'returns', component: ReturnsPolicyComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'shopping-cart', component: ShoppingCartComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'admin/overview', component: AdminOverviewComponent, canActivate: [AuthGuard] },
  { path: 'admin/orders', component: AdminOrdersComponent, canActivate: [AuthGuard] },
  // { path: 'admin/order/:orderNumber', component: AdminOrderDetailComponent, canActivate: [AuthGuard] },
  { path: 'admin/image-list', component: ImageListComponent, canActivate: [AuthGuard] },
  { path: 'admin/stock-list', component: StockListComponent, canActivate: [AuthGuard] },
  { path: 'admin/stock-item/:code', component: ManageStockItemComponent, canActivate: [AuthGuard] },
  { path: 'private', component: HomeComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '404', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/404' }
];
